const pt = {
    message: {
        //
    }
}

export default pt



// WEBPACK FOOTER //
// ./src/translations/lang/pt.js